import { Navigate } from "react-router-dom";
import { localStorageKeys, urlRoutes } from "../constants/page";

export default function ProtectedRoute({ children }) {
  const token =
    localStorage.getItem(localStorageKeys.accessToken) ||
    localStorage.getItem(localStorageKeys.refreshToken);

  if (!token) {
    return <Navigate to={urlRoutes.login} replace />;
  }

  return children;
}
